import type { ComponentPropsWithoutRef } from 'react';

import type { SearchLocation } from '@/scopes/search/search/infrastructure/api/types';
import { styled } from 'styled-components';
import { tk, Icon, Typography } from '@sunwebgroup/ui-components';

type LocationTagProps = ComponentPropsWithoutRef<'p'> & {
  locations: SearchLocation[];
};

export function LocationTag({ locations, ...attributes }: LocationTagProps) {
  return (
    <StyledLocationTag $variant="body-xs" {...attributes}>
      <Icon glyph="IconPin" size="sm" />
      <span>
        {locations
          .map((location) => location.name)
          .reverse()
          .join(', ')}
      </span>
    </StyledLocationTag>
  );
}

LocationTag.displayName = 'LocationTag';

const StyledLocationTag = styled(Typography)`
  align-items: center;
  color: ${tk('color_semantic_text_strong')};
  display: flex;
  margin-top: ${tk('spacing_xs')};

  & > *:first-child {
    flex-shrink: 0;
    margin-right: ${tk('spacing_2xs')};
  }
`;
